<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Tyler Route Processor</span><br/>
      <span style="font-style: italic; font-size: 18px">manually run tyler routes and email log to you when complete</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      &nbsp;&nbsp;&nbsp;Locations:&nbsp;<b-form-select v-if="location_options.length > 0" v-model="selected_location" :options="location_options" style="font-size: 20px; font-weight: bold; width:350px"/>
      &nbsp;&nbsp;&nbsp;<b-button v-on:click.prevent="process_routes(true)" :disabled="this.loading">Run In QA</b-button>
      &nbsp;&nbsp;&nbsp;<b-button v-on:click.prevent="process_routes(false)" :disabled="this.loading">Run In Prod</b-button>
    </div>

    <div v-if="items.length > 0" >
        <div v-for="item in items" style="border: 1px solid black;margin: 6px; padding: 10px; text-align: left">
          {{item}}
        </div>
    </div>
  </div>
</template>

<script>

import {api_url, get_tyler_route_options, process_tyler_routes} from '../networking/tbn_apis'
import {mapState} from "vuex";
import moment from 'moment'
import axios from 'axios';

export default {
  name: 'tyler_route_processor',
  components: {
  },

  data() {
    return {
      remarks_filter: '',
      items: [],
      summary: [],
      loading: false,
      selected_location: '',
      location_options: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  methods: {
    async check_features() {
      this.driver_options = []
      try {
        const {value: {data = []}} = await get_tyler_route_options(this.user.tenant)
        this.location_options = data
      } catch(e) {
        this.$emit('showAlert', 'error loading data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    async process_routes(inQA) {
      this.loading = true
      this.items = []
      try {
        this.$emit('showAlert', 'processing import for ' + this.selected_location + ', this may timeout, but results will be emailed to you once completed', 'info', 60000)
        const {value: { data = [] } } = await process_tyler_routes(this.user.tenant, this.selected_location, inQA)
        this.items = data
        this.$emit('showAlert', 'finished processing import for ' + this.selected_location, 'success', 5000)
      } catch(e) {
        this.$emit('showAlert', 'error processing import for ' + this.selected_location, 'danger', 5000)
      }
      this.loading = false
    },
    // async download(){
    //   this.$emit('showAlert', 'processing download request', 'info', 5000)
    //   axios.defaults.headers.common.Accept = {}
    //   axios.post(
    //       `${api_url}bookings/hos/history/download`,
    //       {
    //         tenant: this.user.tenant,
    //         start_date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
    //         end_date: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
    //         selected_driver: this.selected_driver,
    //         selected_status: this.selected_status,
    //         remarks_filter: this.remarks_filter,
    //       }, {
    //         headers: {
    //           Authorization: `Bearer ${localStorage.getItem('jwt')}`,
    //           Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    //         },
    //         responseType: 'blob'
    //       }
    //   ).then((response) => {
    //     axios.defaults.headers.common.Accept = 'application/json'
    //     const url = window.URL.createObjectURL(new Blob([response.data]))
    //     const link = document.createElement('a')
    //     link.href = url
    //     link.setAttribute(
    //         'download',
    //         `hos-event-history-${this.details_fromDate}-${this.details_toDate}.csv`
    //     )
    //     document.body.appendChild(link)
    //     link.click()
    //     this.$emit('showAlert', 'download complete', 'success', 5000)
    //   }).catch(e => {
    //     axios.defaults.headers.common.Accept = 'application/json'
    //     this.$emit('showAlert', 'alert data could not be downloaded.', 'danger')
    //   })
    // },
    get_row_color(item, type) {
      if (item != null)
        return item.hosStatusType
    },
    filter_by_status(status) {
        this.selected_status = status
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
  }
}
</script>

<style>

</style>

